import { delay, call, takeLatest, fork, put, all } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import * as api from '../../services/apiAdmin';
import * as SAGATYPES from '../../constants/constant_saga_types';
import * as actions from '../../actions/actionCreatorGlobalSearch';

export default function* (feathersApp) {
  return yield all([fork(searchTermSaga, feathersApp)]);
}

function* searchTermSaga(feathersApp) {
  yield takeLatest(SAGATYPES.SEARCH_TERM, callSearchTerm, feathersApp);
}
function* callSearchTerm(feathersApp, action) {
  try {
    yield put(actions.searchingTerm());
    yield delay(250);

    const { search_term, force_show_results } = action;

    if (isEmpty(search_term)) return;

    const results = yield call(api.searchTerm, feathersApp, search_term);

    yield put(
      actions.doneSearchingTerm({ ...results, search_term, force_show_results })
    );
  } catch (error) {
    console.error('ERROR @ SAGA GLOBAL SEARCH : ', error);
    yield put(actions.errorSearchingTerm(error));
  }
}
